/*
 * @Description: add errorCode
 * @Author: aaronwn
 * @Date: 2019-10-09 14:12:14
 * @LastEditTime: 2019-10-09 14:30:14
 * @LastEditors: Please set LastEditors
 */
import Toast from 'service/comp/toast'
import SRC_CONFIG from 'src/config'
import hooks from './hooks'

/**
 * service 对象
 */
let service

/**
 * httpType 请求类型
 */
let httpType

/**
 * @type {Toast} Toast实例对象
 */
const toast = new Toast()

/**
 * 登出页面地址
 */
const LOGOUT_PAGE = SRC_CONFIG.LOGOUT_PAGE || '//www.aixuexi.com/logout.html'

/**
 * 请求service的具体函数
 */
function serviceRequest(params, ...rest) {
  hooks.init(params)
  hooks.handles.beforeSend()

  if (!service || !httpType) {
    console.warn('[service request]: Before calling serviceRequest, please call request.init function, and introduced service and httpType two parameters')
  }

  return new Promise((resovle, reject) => {
    service[httpType](
      params,

      (response) => {
        let resData = response.data || response
        if (!resData) {
          toast.show({ message: '没有无数据' })
          return false
        }

        // 数据可能为字符串返回, 需要转义一下
        if (typeof resData === 'string') {
          resData = JSON.parse(resData)
        }

        if (resData.status === 1) {
          // 成功的值传入回调
          hooks.handles.afterSend({ response })
          resovle(handlerData(resData))
        } else {
          showErrorMsg(reject, params, resData)
        }
      },
      err => {
        // 请求成功，但是请求信息有误
        showErrorMsg(reject, params, err)
      },

      ...rest
    )
  })
}

/**
 * 处理数据
 * 服务端返回的有时候是 obj.body || obj.data 
 * obj.data 可能存在0的情况
 */
function handlerData(obj) {
  let _data = obj.body || obj.data

  if (_data != null) {
    return _data || _data === 0 && _data
  }
}

// 1003：已在其他端登录            需要登出
// 1006：TOKEN 已经过期           需要登出
// 1007：会话不存在或会话已过期     需要登出
// 1009：TOKEN 解析失败           需要登出
// 1010：服务异常
// 1011：未知错误
// 1012：参数错误                 需要登出
// 1014：刷新TOKEN 失效
/**
 * 弹出错误信息
 * 可能会回调首页重新登录
 */
function showErrorMsg(reject, params, response) {
  const { settings: {isToast, checkLogin} } = params
  const { errorMessage: message, errorCode: code } = response
  const debugMsg = `[service request]: url: ${params.url} , message: ${message}`
  const duration = 5000
 
  // loginfo接口
  if(checkLogin == false) {
    reject(message)
    return false
  }
  
  if(code == 1003 || code == 1006 || code == 1007 || code == 1009 || code == 1012) {
    toast.show({ message: `${code}：${message}，账号即将退出，请重新登录`, duration })
    setTimeout(() => {
      location.href = LOGOUT_PAGE + `?loginBackUrl=${location.href}`
      return toast.destroy()
    }, duration);
  } else {
    reject(message)
    // code == 1010 || code == 1011 时把错误码显示出来
    let showMessage = (code == 1010 || code == 1011) ? `${code}：${message}` : message
    isToast && toast.show({ message: showMessage || '请求失败，请重试!' })
  }

}

export default {
  init(_service, _httpType) {
    service = _service
    httpType = _httpType

    return this
  },

  serviceRequest
}